import Card from 'antd/es/card';
import { styled } from 'styled-components';

const StyledCard = styled(Card)`
  ${({ theme }) => `
  width: 100%;
  max-width: ${theme.screenLG / 1.98}px;
  box-shadow: ${theme.boxShadowSecondary};
  border: 0px;

  .ant-typography {
    font-family: 'Inter', sans-serif !important;
  }
`}
`;

interface UnauthCardProps {
  children: React.ReactNode;
}

const UnauthCard = ({ children }: UnauthCardProps) => {
  return <StyledCard>{children}</StyledCard>;
};

export default UnauthCard;
